import Icon from '../components/Icon.vue'

Icon.register({
  'car-side': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 192H528L419.2 56A64-64 0 0 1 369.2 32H155.3C129.2 32 105.6 47.9 95.9 72.2L48 194.3C20.4 201.4 0 226.2 0 256V368C0 376.8 7.2 384 16 384H64C64 437 107 480 160 480S256 437 256 384H384C384 437 427 480 480 480S576 437 576 384H624C632.8 384 640 376.8 640 368V288C640 235 597 192 544 192zM160 432C133.5 432 112 410.5 112 384S133.5 336 160 336 208 357.5 208 384 186.5 432 160 432zM232 192H116.9L155.3 96H232V192zM280 192V96H369.2L446 192H280zM480 432C453.5 432 432 410.5 432 384S453.5 336 480 336 528 357.5 528 384 506.5 432 480 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/car-side.js
// module id = ISNk
// module chunks = 144